import { Component } from '@angular/core';

@Component({
	selector: 'app-setup-wizard-finished',
	imports: [],
	standalone: true,
	templateUrl: './setup-wizard-finished.html',
	styleUrl: './setup-wizard-finished.scss',
})
export class SetupWizardFinished {}
